<template>
  <v-dialog :value="value" width="250" persistent>
    <v-card>
      <v-card-title>Set CPL</v-card-title>

      <v-card-text class="pb-4">

        <div class="font-weight-bold mb-2">Set CPL for the selected leads</div>
        <v-text-field v-model="cpl" label="CPL (£)" type="number" autofocus hide-details outlined dense></v-text-field>

      </v-card-text>

      <v-divider />
      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn color="primary" small @click="submit" :disabled="getSetCplLoading" :loading="getSetCplLoading">SAVE</v-btn>
        <v-btn color="primary" small outlined @click="close" :disabled="getSetCplLoading" :loading="getSetCplLoading">CLOSE</v-btn>

      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

  import { mapGetters,mapActions } from 'vuex';

  export default {

    props: ['value'],

    data() {
      return {
        cpl: ''
      }
    },

    computed: {
      ...mapGetters('cpl',['getSelectedCplLeadIds','getSetCplLoading','getSetCplError']),
    },

    methods: {
      ...mapActions('cpl',['setCpl']),

      async submit() {
        await this.setCpl({leads:this.getSelectedCplLeadIds,cpl:this.cpl});
        if(!this.getSetCplError){ this.close(); }
      },

      close() {
        this.cpl = '';
        this.$emit('input', false);
      },
    },

  }
</script>

<style lang="scss" scoped></style>
